import { useState } from 'react';
import { FiMoon, FiSun } from 'react-icons/fi';
import AdminIconButton from './AdminIconButton';

const STORAGE_KEY = 'ken-bryn-admin-theme';

export function useAdminTheme() {
  const [theme, setTheme] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) === 'light' ? 'light' : 'dark'; }
    catch { return 'dark'; }
  });
  function toggleTheme() {
    const next = theme === 'dark' ? 'light' : 'dark';
    setTheme(next);
    try { localStorage.setItem(STORAGE_KEY, next); } catch { /* Theme still works when storage is unavailable. */ }
  }
  return { theme, toggleTheme };
}

export function AdminThemeToggle({ theme, onToggle }) {
  return <AdminIconButton label="Dark mode" title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'} icon={theme === 'dark' ? FiSun : FiMoon} className="admin-theme-toggle" aria-pressed={theme === 'dark'} onClick={onToggle} />;
}
